import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <h1>Welcome To my Site</h1>
            <h3>We want to form a very simple list of Writter</h3>
            <p>Budget is : 1000 Taka(actully not needed)</p>
        </div>
    );
};

export default Header;